import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'src/app/shared/service/shared.service';

@Component({
  selector: 'app-category-popup',
  templateUrl: './category-popup.component.html',
  styleUrls: ['./category-popup.component.scss']
})
export class CategoryPopupComponent implements OnInit {
  clusterList: any[] = [];
  categoryList: any[] = [];
  selectedCluster: any;
  selectedCategory: any;
  filteredData: any = {
    cluster: {
      list: [],
      searchText: ''
    },
    category: {
      list: [],
      searchText: ''
    }
  };
  categoryDisabled: boolean;
  disableSubmit: boolean;
  uniqueClusterList: any;

  constructor(
    public dialogRef: MatDialogRef<CategoryPopupComponent>,
    private service: SharedService
  ) { }

  ngOnInit() {
    this.getCluster();
  }

  close_dialogue(btnClicked: any) {
    const data = {
      clickedBtn: btnClicked,
      selectedCluster: '',
      selectedCategory: ''
    };

    if (btnClicked === 'select') {
      data.selectedCluster = this.selectedCluster;
      data.selectedCategory = this.selectedCategory;
    }

    this.dialogRef.close(data);
  }
  /* istanbul ignore next */
  getCluster() {
    this.filteredData.cluster.searchText = null;
    this.filteredData.category.searchText = null;
    this.filteredData.category.list = [];
    this.categoryList = [];
    this.selectedCategory = null;

    this.categoryDisabled = true;
    this.disableSubmit = true;

    // this.service.getClusterList().subscribe(result => {
    const clusters = JSON.parse(sessionStorage.getItem('dfos.userfactory.data'));
    if (clusters) {
      this.clusterList = clusters;
      this.filteredData.cluster.list = this.clusterList;
      this.uniqueClusterList = [];
      this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];

      // let testList = this.filteredData.cluster.list;
      console.log('testlist', this.uniqueClusterList);
      if (this.clusterList && this.clusterList.length === 1) {
        this.selectedCluster = this.clusterList[0];
        this.filteredData.cluster.searchText = this.clusterList[0];
        // this.getCategory();
      }
    }
    // });
  }

  getCategory() {
    if (this.selectedCluster) {
      // this.service.getTopFactoryList(this.selectedCluster).subscribe(result => {
      this.service.getCategoryList({ cluster: this.selectedCluster }, { bigCat: { id: null } }).subscribe(result => {
        this.categoryList = result;
        // this.filteredData.category.list = this.categoryList;
        // this.categoryDisabled = false;

        // if (this.categoryList && this.categoryList.length === 1) {
        //   this.selectedCategory = this.categoryList[0];
        //   this.filteredData.category.searchText = this.categoryList[0];
        // }
      });
    }
  }

  clusterValueMapper = (selectedObj) => {
    if (selectedObj) {
      const selection = this.clusterList.find(e => {
        return e.name === selectedObj.name;
      });
      if (selection) {
        this.selectedCluster = selection;
        // this.getCategory();
        this.disableSubmit = false;
        return selection.name;
      }
    }
  }

  categoryValueMapper = (selectedObj) => {
    if (selectedObj) {
      const selection = this.categoryList.find(e => {
        return e.name === selectedObj.name;
      });
      if (selection) {
        this.selectedCategory = selection;
        return selection.name;
      }
    }
  }
  /* istanbul ignore next */
  autoComplete(event: string, changedFilter: string) {
    const evt = event + '';

    switch (changedFilter) {
      case 'cluster':
        this.filteredData.category.searchText = null;
        this.filteredData.category.list = [];
        this.categoryList = [];
        this.selectedCategory = null;

        this.categoryDisabled = true;
        // this.disableSubmit = true;

        if (evt) {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList = this.uniqueClusterList.filter
            (item => (item.id + '') === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
        } else {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList.sort((a, b) => a.name.localeCompare(b.name));
        }
        break;

      case 'category':
        if (evt) {
          const clonedFactoryList = [...this.categoryList];
          this.filteredData.category.list = clonedFactoryList.filter
            (item => (item.name + '') === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
        } else {
          this.uniqueClusterList = [...new Map(this.clusterList.map((m) => [m.name, m])).values()];
          this.uniqueClusterList.sort((a, b) => a.name.localeCompare(b.name));
          this.filteredData.category.list = this.categoryList;
          this.filteredData.category.list.sort((a, b) => a.name.localeCompare(b.name));
        }
        /* if (evt) {
          this.filteredData.category.list = this.categoryList.filter
            (item => (item.id + '') === evt || item.name.toLocaleLowerCase().indexOf(evt.toLocaleLowerCase()) >= 0);
        } else {
          this.filteredData.category.list = this.categoryList;
        } */
        break;
    }

    if (this.filteredData.category.list.length >= 1) {
      this.selectedCategory = null;
      this.disableSubmit = true;
    }
  }

}
